'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'refrigerator';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e026';
var svgPathData = ['M32 96l0 64 224 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0-64c0-35.3-28.7-64-64-64L96 32C60.7 32 32 60.7 32 96zm0 96l0 256c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-256-64 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-224 0z', 'M288 32c35.3 0 64 28.7 64 64l0 64-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-224 0 0-64c0-35.3 28.7-64 64-64l192 0zM256 192l0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144 64 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256 224 0zM96 0C43 0 0 43 0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-53-43-96-96-96L96 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRefrigerator = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;